import type { DiagnosisSeite } from 'types/immunization';

export const SEITE_SELECT_OPTIONS: {
  value: DiagnosisSeite;
  code: string;
  translationKey: 'links' | 'rechts' | 'beidseitig' | 'keine_angabe';
}[] = [
  { value: '', code: '-', translationKey: 'keine_angabe' },
  { value: 'L', code: 'L', translationKey: 'links' },
  { value: 'R', code: 'R', translationKey: 'rechts' },
  { value: 'B', code: 'B', translationKey: 'beidseitig' },
];
